export const apiUrl =
  process.env.REACT_APP_API_URL ?? 'https://api.staging.toolings.co';

export const roleOptions = [
  { value: 'admin', label: 'Admin' },
  { value: 'member', label: 'Member' },
  { value: 'guest', label: 'Guest' },
  { value: 'super_admin', label: 'Super Admin' },
];
